import React, { useState, useEffect } from 'react';

export default function HourglassSpinner() {
  const getState = () => {
    const now = new Date();
    const msIntoHour = (now.getMinutes() * 60 * 1000) + (now.getSeconds() * 1000) + now.getMilliseconds();
    return Math.floor(msIntoHour / 1200);
  };

  const [state, setState] = useState(getState);
  const [rotation, setRotation] = useState(() => Math.floor(getState() / 3) * 180);

  useEffect(() => {
    const scheduleNext = () => {
      const now = new Date();
      const msIntoHour = (now.getMinutes() * 60 * 1000) + (now.getSeconds() * 1000) + now.getMilliseconds();
      const msUntilNextBoundary = 1200 - (msIntoHour % 1200);
      
      return setTimeout(() => {
        const newState = getState();
        setState(prev => {
          // Increment rotation when crossing into new cycle (every 3 states)
          if (Math.floor(newState / 3) > Math.floor(prev / 3)) {
            setRotation(r => r + 180);
          }
          return newState;
        });
        timeoutId = scheduleNext();
      }, msUntilNextBoundary);
    };

    let timeoutId = scheduleNext();

    return () => clearTimeout(timeoutId);
  }, []);

  const iconState = state % 6; // 6 states total (3 up, 3 flipped)
  const displayState = iconState % 3;
  const isFlipped = iconState >= 3;

  const getIcon = () => {
    // Reverse the sequence when flipped so animation continues in same direction
    const actualState = isFlipped ? 2 - displayState : displayState;
    switch(actualState) {
      case 0:
        return 'fa-hourglass-start';
      case 1:
        return 'fa-hourglass-half';
      case 2:
        return 'fa-hourglass-end';
      default:
        return 'fa-hourglass-start';
    }
  };

  return (
    <i 
      className={`fa-solid ${getIcon()}`}
      style={{
        opacity: 0.5,
        transform: `rotate(${rotation}deg)`,
        transition: 'transform 0.3s ease',
        display: 'inline-block'
      }}
    />
  );
}
